import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import dayjs from 'dayjs';

import { actions } from 'features/transaction';

export const useActiveRequests = () => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale);
  const { actionProcessing, activeRequests } = useSelector(state => state.transaction, shallowEqual);
  const { currency } = useSelector(state => state.auth, shallowEqual);

  const [values, setValues] = useState({
    note: '',
    page: 0,
    count: 7,
  });

  const [activeItem, setActiveItem] = useState(null);

  const pages = Math.ceil(activeRequests.items.length / values.count);

  const items = activeRequests.items.slice(values.page * values.count, (values.page + 1) * values.count).map(item => ({
    ...item,
    date: dayjs(item.date).format('DD.MM.YYYY'),
    amount: `${item.amount} ${currency}`,
  }));

  const handleNoteChange = value => {
    setValues(ps => ({
      ...ps,
      note: value,
    }));
  };

  const handleItemOpen = item => {
    setActiveItem(item);
  };

  const handleItemClose = () => {
    setActiveItem(null);
    setValues(ps => ({ ...ps, note: '' }));
  };

  const handlePageChange = page => {
    setValues(ps => ({ ...ps, page }));
  };

  const handleActiveRequestsGet = () => {
    dispatch(
      actions.getActiveRequests({
        page: values.page,
        count: values.count,
      }),
    );
  };

  const handleRequestApprove = ({ id }) => {
    dispatch(
      actions.setRequestStatus({
        id,
        status: 1,
        callback: () => {
          setValues(ps => ({ ...ps, note: '' }));
          handleActiveRequestsGet();
        },
      }),
    );
  };

  const handleRequestReject = () => {
    dispatch(
      actions.setRequestStatus({
        id: activeItem.id,
        comment: values.note,
        status: 2,
        callback: () => {
          setValues(ps => ({ ...ps, note: '' }));
          setActiveItem(null);
          handleActiveRequestsGet();
        },
      }),
    );
  };

  useEffect(() => {
    handleActiveRequestsGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.page]);

  return {
    input: {
      values,
      activeItem,
      handleNoteChange,
      handleRequestApprove,
      handleRequestReject,
      handleItemOpen,
      handleItemClose,
      handlePageChange,
    },
    output: {
      locale,
      actionProcessing,
      items,
      pages,
      currency,
    },
  };
};
